import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import { PaginatedResponse } from '../../../interfaces/PaginatedResponse';
import { Review } from '../../../interfaces/Review/Review';
import { getReviews } from '../../../api/Review';
import { ReviewsTable } from '../../Review/ReviewsTable';

const pagination = { page: 0, pageSize: 5 };

export const ReviewsWidget = () => {
  const [reviews, setReviews] = useState<PaginatedResponse<Review>>({
    data: [],
    totalCount: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getReviews({
      search: '',
      pagination,
    })
      .then((r) => setReviews(r))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        py: 0,
        px: 2,
        gap: 1.5,
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', my: 3, gap: 1.5 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <CommentIcon />

          <Typography variant='h6'>Son Değerlendirmeler</Typography>
        </Box>

        {loading ? (
          <Skeleton variant='rectangular' height={200} width='100%' />
        ) : (
          <ReviewsTable
            reviews={reviews.data}
            totalCount={reviews.totalCount}
            pagination={pagination}
            variant='compact'
            headless
          />
        )}
      </Box>
    </Paper>
  );
};
